import { Edges } from "@react-three/drei";
import PrototypeManager from "../../WaveFunctionCollapseV2/Prototype/PrototypeManager.ts";
import { Vector3 } from "three";
import Cell from "../../WaveFunctionCollapseV2/Cell.ts";

interface EmptyCellProps {
  cell: Cell;
  cellSize: number;
  position: Vector3;
  onClick: (event: any) => void;
}

export default function EmptyCell({
  cell,
  cellSize,
  position,
  onClick,
}: EmptyCellProps): JSX.Element {
  return (
    <mesh
      position={position}
      onClick={(event) => {
        onClick(event);
      }}
    >
      <boxGeometry args={[cellSize, cellSize, cellSize]} />
      <meshStandardMaterial transparent color={"yellow"} opacity={0.4} />
      <Edges linewidth={1} threshold={15} color={"black"} />
    </mesh>
  );
}
